export default __webpack_public_path__ + "static/media/31.804a6d99.jpg";